(function () {
  'use strict';
  var panel = document.querySelector('[data-wishlist]');
  if (!panel || !panel.showModal) return;
  var key = 'jjw:wishlist:v1';
  var items = [];
  var storageAvailable = true;
  var opener;
  var previousOverflow = '';
  var list = panel.querySelector('[data-wishlist-list]');
  var template = panel.querySelector('[data-wishlist-template]');
  var status = document.querySelector('[data-wishlist-status]');
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function clean(value) {
    if (!Array.isArray(value)) return [];
    var seen = new Set();
    return value.filter(function (item) {
      if (!item || !/^\d+$/.test(String(item.id)) || typeof item.handle !== 'string' || !/^[a-z0-9-]+$/.test(item.handle) || typeof item.title !== 'string' || seen.has(String(item.id))) return false;
      seen.add(String(item.id));
      return true;
    }).slice(0, 100).map(function (item) {
      var image = typeof item.image === 'string' ? item.image : '';
      // Stored content is untrusted; only Shopify-hosted image URLs are accepted.
      try {
        var url = new URL(image, location.origin);
        if (url.protocol !== 'https:' || (url.hostname !== location.hostname && url.hostname !== 'cdn.shopify.com')) image = '';
      } catch (error) { image = ''; }
      return { id: String(item.id), handle: item.handle, title: item.title.slice(0, 240), image: image };
    });
  }
  function read() {
    var stored;
    try { stored = localStorage.getItem(key); }
    catch (error) { storageAvailable = false; return; }
    // A blocked write can leave an older value readable. Keep this visit's
    // in-memory list until storage works again instead of reviving stale saves.
    if (!storageAvailable) return;
    try { items = clean(JSON.parse(stored || '[]')); }
    catch (error) { items = []; }
  }
  function announce(message) {
    status.textContent = message;
    panel.querySelector('[data-wishlist-feedback]').textContent = message;
  }
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(items)); storageAvailable = true; }
    catch (error) { storageAvailable = false; }
  }
  function sync() {
    document.querySelectorAll('[data-wishlist-save]').forEach(function (button) {
      var saved = items.some(function (item) { return item.id === button.dataset.productId; });
      button.hidden = false;
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? panel.dataset.removeProduct : panel.dataset.saveProduct).replace('[product]', button.dataset.productTitle));
      var label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? panel.dataset.saved : panel.dataset.save;
    });
    document.querySelectorAll('[data-wishlist-open]').forEach(function (button) { button.hidden = false; });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (count) { count.textContent = items.length; });
  }
  function render() {
    list.replaceChildren();
    panel.querySelector('[data-wishlist-empty]').hidden = items.length > 0;
    items.forEach(function (item) {
      var row = template.content.cloneNode(true);
      row.querySelector('.wl-item').dataset.wishlistId = item.id;
      row.querySelectorAll('[data-wishlist-link]').forEach(function (link) { link.href = root + 'products/' + item.handle; });
      row.querySelector('.wl-item__title').textContent = item.title;
      var img = row.querySelector('img');
      if (item.image) {
        img.src = item.image;
        img.addEventListener('error', function () { img.hidden = true; img.nextElementSibling.hidden = false; });
      } else { img.hidden = true; img.nextElementSibling.hidden = false; }
      var remove = row.querySelector('[data-wishlist-remove]');
      remove.dataset.wishlistRemove = item.id;
      remove.setAttribute('aria-label', panel.dataset.removeProduct.replace('[product]', item.title));
      list.appendChild(row);
    });
    sync();
  }
  function refreshProducts() {
    items.forEach(function (item) {
      fetch(root + 'products/' + encodeURIComponent(item.handle) + '.js')
        .then(function (response) {
          if (response.status === 404) return null;
          if (!response.ok) throw new Error('Product lookup failed');
          return response.json();
        })
        .then(function (product) {
          var row = list.querySelector('[data-wishlist-id="' + item.id + '"]');
          if (!row || !panel.open) return;
          if (!product) {
            row.querySelectorAll('[data-wishlist-link]').forEach(function (link) { link.removeAttribute('href'); });
            row.querySelector('.wl-item__choose').textContent = panel.dataset.unavailable;
            return;
          }
          var updated = clean([{ id: item.id, handle: item.handle, title: product.title, image: product.featured_image }])[0];
          if (!updated) return;
          row.querySelector('.wl-item__title').textContent = updated.title;
          var img = row.querySelector('img');
          if (updated.image) { img.hidden = false; img.nextElementSibling.hidden = true; img.src = updated.image; }
        })
        .catch(function () { /* Keep saved details when offline; size and price are chosen on the PDP. */ });
    });
  }
  function open(button) {
    opener = button;
    document.dispatchEvent(new CustomEvent('jjw:wishlist-open'));
    read();
    render();
    panel.querySelector('[data-wishlist-feedback]').textContent = storageAvailable ? '' : panel.dataset.storageError;
    previousOverflow = document.body.style.overflow;
    panel.showModal();
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-wishlist-open]').forEach(function (control) { control.setAttribute('aria-expanded', 'true'); });
    panel.querySelector('[data-wishlist-close]').focus();
    refreshProducts();
  }
  function change(id, product) {
    // Read the latest state so two open storefront tabs don't overwrite each other's saves.
    if (storageAvailable) read();
    var index = items.findIndex(function (item) { return item.id === id; });
    if (index >= 0) items.splice(index, 1);
    else if (product) {
      if (items.length >= 100) { announce(panel.dataset.limit); return; }
      items = clean(items.concat([product]));
    }
    persist();
    sync();
    announce(storageAvailable ? (index >= 0 ? panel.dataset.removed : panel.dataset.added) : panel.dataset.storageError);
  }
  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) { event.preventDefault(); open(openButton); return; }
    var save = event.target.closest('[data-wishlist-save]');
    if (save) {
      change(save.dataset.productId, { id: save.dataset.productId, handle: save.dataset.productHandle, title: save.dataset.productTitle, image: save.dataset.productImage });
      return;
    }
    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      var index = Array.from(list.querySelectorAll('[data-wishlist-remove]')).indexOf(remove);
      change(remove.dataset.wishlistRemove);
      render();
      var buttons = list.querySelectorAll('[data-wishlist-remove]');
      (buttons[Math.min(index, buttons.length - 1)] || panel.querySelector('[data-wishlist-close]')).focus();
    }
  });
  panel.querySelector('[data-wishlist-close]').addEventListener('click', function () { panel.close(); });
  panel.addEventListener('click', function (event) {
    if (event.target !== panel) return;
    var bounds = panel.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) panel.close();
  });
  panel.addEventListener('close', function () {
    document.body.style.overflow = previousOverflow;
    document.querySelectorAll('[data-wishlist-open]').forEach(function (control) { control.setAttribute('aria-expanded', 'false'); });
    if (opener && opener.isConnected) opener.focus();
  });
  window.addEventListener('storage', function (event) {
    if (event.key !== key && event.key !== null) return;
    read();
    if (panel.open) render(); else sync();
  });
  document.addEventListener('shopify:section:load', sync);
  read();
  sync();
})();
